// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import App from './App';
import store from './store';
import router from './router';
import VuesticPlugin from 'vuestic-theme/vuestic-plugin';
import './i18n';
import YmapPlugin from 'vue-yandex-maps';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import Multiselect from 'vue-multiselect';
import VueHtml2Canvas from 'vue-html2canvas';
import VueTimers from 'vue-timers';
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import VueTheMask from 'vue-the-mask'

import rolePlugin from './directives/RolePlugin.js'

import VuejsDialog from "vuejs-dialog"

Vue.use(rolePlugin);

Vue.use(VuejsDialog, {
    okText: 'Sim',
    cancelText: 'Não',
    animation: 'bounce', 
});

Vue.use(VueTheMask)
Vue.use(Croppa);
Vue.use(Loading);
Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(VueHtml2Canvas);
Vue.use(VueTimers);
// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {
	fieldsBagName: 'formFields',
	locale: 'pt_BR',
	dictionary: {es, pt_BR}
});

Vue.component('multiselect', Multiselect)

Validator.localize('pt_BR');

let mediaHandler = () => {
	if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
		store.dispatch('toggleSidebar', true)
	} else {
		store.dispatch('toggleSidebar', false)
	}
}

router.beforeEach((to, from, next) => {
	store.commit('setLoading', true)
	next()
})

router.afterEach((to, from) => {
	mediaHandler()
	store.commit('setLoading', false)
})

/* eslint-disable no-new */

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js